import { useSelector } from 'react-redux';
import useQueryParams from '~/hooks/useQueryParams';
import { RootState } from '~/store';
import { useGetClientDataQuery } from '~/store/apis/endpoints/myPagesUnauthenticatedApi/clientData/clientData.api';

export const useGetClientData = () => {
  const { market } = useSelector((state: RootState) => state.intl);

  const queryParams = useQueryParams();
  const qCode = queryParams.get('qcode') ?? '';

  const {
    data: clientData,
    isFetching: isFetchingClientData,
    isError,
  } = useGetClientDataQuery(
    {
      qCode: qCode,
      market,
    },
    {
      skip: !qCode,
    }
  );

  return {
    isFetchingClientData,
    isError,
    clientData,
    qCode,
  };
};
